import { matchupCentreIndex } from '~/apps/product-plus/search-domain/indexes';
import { buildMatchupCentreQuery } from '~/apps/product-plus/search-domain/pipelines/match-centre/build-query';
import {
  getMatchupCentreBaseFilters,
  getMatchupCentreFacetAttributes,
  getMatchupCentreSearchSettings,
  getMatchupCentreSorting,
} from '~/apps/product-plus/search-domain/pipelines/match-centre/query-config';
import { transformMatchupCentreResponse } from '~/apps/product-plus/search-domain/pipelines/match-centre/transform-response';
import { type MatchupCentreESResultBody } from '~/apps/product-plus/search-domain/pipelines/match-centre/types';
import { type SearchPipelineDefinition, type SearchUiState } from '~/apps/product-plus/search-domain/types';

const resolveMatchupCentreSorting = (context: Parameters<typeof getMatchupCentreSorting>[0]) =>
  getMatchupCentreSorting(context);

export const matchupCentrePipelineDefinition: SearchPipelineDefinition<SearchUiState, MatchupCentreESResultBody> = {
  buildSearchRequest: buildMatchupCentreQuery,
  facetAttributes: context => getMatchupCentreFacetAttributes(context),
  getBaseFilters: context => getMatchupCentreBaseFilters(context),
  getSearchUiConfig: context => ({
    searchAttributes: getMatchupCentreSearchSettings().search ?? [],
    sorting: () => resolveMatchupCentreSorting(context),
  }),
  getSorting: context => resolveMatchupCentreSorting(context),
  id: matchupCentreIndex,
  searchSettings: () => getMatchupCentreSearchSettings(),
  transformResponse: transformMatchupCentreResponse,
};
